import apiClient from "./Api";

//=============================================================================
// LAYERS GROUPS
//=============================================================================
/**
 * Obtiene todos los grupos de capas de un proyecto específico.
 * @param {string} projectUuid
 */
export const getLayerGroups = async (projectUuid) => {
  // Endpoint swagger: GET /gis/layers_groups/{project_uuid}
  const response = await apiClient.get(`/gis/layers_groups/${projectUuid}`);
  return response.data;
};

/**
 * Crea una relación entre un proyecto y un grupo de capas.
 * @param {string} projectUuid
 * @param {string} layerGroupUuid
 */
export const linkLayerGroupToProject = async (projectUuid, layerGroupUuid) => {
  // Endpoint swagger: POST /gis/layers_groups/link_to_project/{project_uuid}/{layer_group_uuid}
  const response = await apiClient.post(
    `/gis/layers_groups/link_to_project/${projectUuid}/${layerGroupUuid}`
  );
  return response.data;
};

/**
 * Crea un nuevo grupo de capas.
 * @param {Object} layerGroupData - Objeto conforme a LayersGroupCreate
 */
export const createLayerGroup = async (layerGroupData) => {
  // Endpoint swagger: POST /gis/layer_group
  const response = await apiClient.post("/gis/layer_group", layerGroupData);
  return response.data;
};

/**
 * Obtiene un grupo de capas por UUID.
 * @param {string} groupUuid
 */
export const getLayerGroupByUuid = async (groupUuid) => {
  // Endpoint swagger: GET /gis/layer_group/{group_uuid}
  const response = await apiClient.get(`/gis/layer_group/${groupUuid}`);
  return response.data;
};

/**
 * Actualiza un grupo de capas por UUID.
 * @param {string} groupUuid
 * @param {Object} layerGroupData - Objeto con la información actualizada
 */
export const updateLayerGroup = async (groupUuid, layerGroupData) => {
  // Endpoint swagger: PUT /gis/layer_group/{group_uuid}
  const response = await apiClient.put(
    `/gis/layer_group/${groupUuid}`,
    layerGroupData
  );
  return response.data;
};

/**
 * Elimina un grupo de capas por UUID.
 * @param {string} groupUuid
 */
export const deleteLayerGroup = async (groupUuid) => {
  // Endpoint swagger: DELETE /gis/layer_group/{group_uuid}
  const response = await apiClient.delete(`/gis/layer_group/${groupUuid}`);
  return response.data;
};
